<template>
  <hm-content title="">
    <div class="table-panel flex flex-between flex-wrap">
      <div class="mr10">
        <el-button type="primary" size="small" @click="addGoods"
          >添加商品</el-button
        >
        <!-- <el-button type="primary" size="small" @click="brokerage"
          >推会员返佣</el-button
        > -->
      </div>
      <div class="flex text-right item-center flex-wrap">
        <el-input
          clearable
          style="width: 200px"
          v-model.trim="searchCondition.keyword"
          placeholder="请输入货号/条码/商品名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-cascader
          v-model="searchCondition.wxshopCategoryId"
          :show-all-levels="false"
          size="small"
          class="mr10"
          :props="categoryFunc"
          clearable
          placeholder="请选择微店商品分类"
        ></el-cascader>
        <el-cascader
          v-model="searchCondition.attributeId"
          placeholder="请选择辅助属性"
          :show-all-levels="false"
          size="small"
          class="mr10"
          :props="attributeFunc"
          clearable
        ></el-cascader>
        <el-input
          clearable
          style="width: 100px"
          v-model.trim="searchCondition.minPrice"
          placeholder="最低零售价"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          style="width: 100px"
          v-model.trim="searchCondition.maxPrice"
          placeholder="最高零售价"
          size="small"
          class="ipt mr10"
        ></el-input>

        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button type="info" size="small" @click="searchCondition = {}"
          >重置</el-button
        >
        <el-button type="success" size="small" @click="dialogOutPut = true"
          >导出</el-button
        >
      </div>
    </div>
    <div class="table">
      <div class="flex batch flex-between">
        <div>
          <span>已选{{ num }}条</span>
        </div>
        <div>
          <span @click="batchSetting">
            <span class="delete-icon hmicon icon-xitong"></span>
            批量设置
          </span>
          <span @click="batchDelete">
            <span class="delete-icon hmicon icon-shanchu"></span>批量删除
          </span>
        </div>
      </div>
      <el-table
        @sort-change="sortChange"
        stripe
        border
        @selection-change="getChecked"
        ref="table"
        :data="relInfoList.records"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="wxshopSpuName"
          label="商品名称"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.wxshopSpuName }}</span>
            <span v-if="scope.row.specIdGroupName"
              >【{{ scope.row.specIdGroupName }}】</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="wxshopPrice"
          label="价格信息"
        >
          <template slot-scope="scope">
            <div>
              <span>零售价：</span>
              <span class="rose">{{ scope.row.wxshopPrice }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="lastEditTime"
          label="修改日期"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.lastEditTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="specialTimeNum"
          label="特殊时段返佣规则数"
        >
        </el-table-column>
        <el-table-column
          prop="commissionValue"
          header-align="center"
          align="center"
          label="积分返佣比例"
          v-if="commType === 'point'"
        >
          <template slot-scope="scope">
            <div class="flex flex-warp">
              <el-input
                :disabled="scope.row.disabled"
                v-model="scope.row.commissionValue"
                @input="filterGt0OrFixed2('commissionValue', scope.$index)"
                clearable
                style="width:130px;"
                placeholder="请填写积分数"
                size="small"
                class="ipt mr10"
              ></el-input>
              <div class="flex flex-center item-center">%</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="commissionValue"
          label="货币返佣比例"
          v-if="commType === 'money'"
        >
          <template slot-scope="scope">
            <div class="flex flex-warp">
              <el-input
                :disabled="scope.row.disabled"
                v-model="scope.row.commissionValue"
                @input="filterGt0OrFixed2('commissionValue', scope.$index)"
                clearable
                style="width:130px;"
                placeholder="请填写货币数"
                size="small"
                class="ipt mr10"
              ></el-input>
              <div class="flex flex-center item-center">%</div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          width="280px"
          label="启用返佣"
        >
          <template slot-scope="scope">
            <template>
              <el-radio
                :disabled="scope.row.disabled"
                v-model="scope.row.commissionMode"
                label="point"
                >积分</el-radio
              >
              <el-radio
                :disabled="scope.row.disabled"
                v-model="scope.row.commissionMode"
                label="money"
                >货币</el-radio
              >
            </template>
          </template>
        </el-table-column> -->

        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="查看" placement="top">
                <button
                  class="pointer mr10 no-bg"
                  @click="toDetails(scope.row)"
                >
                  <span class="hmicon icon-chakan blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                v-if="scope.row.disabled"
                class="item"
                content="编辑"
                placement="top"
              >
                <button
                  class="pointer mr10 no-bg"
                  @click="edit(scope.row, scope.$index)"
                >
                  <span class="hmicon icon-bianji blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip v-else class="item" content="保存" placement="top">
                <button class="pointer mr10 no-bg" @click="save(scope.row)">
                  <span class="hmicon icon-baocun blue"></span>
                </button>
              </el-tooltip>

              <el-tooltip class="item" content="时段返佣" placement="top">
                <button
                  class="pointer mr10 no-bg"
                  @click="setTimeline(scope.row)"
                >
                  <span class="hmicon icon-yuyueguanli blue"></span>
                </button>
              </el-tooltip>

              <el-tooltip class="item" content="删除" placement="top">
                <button class="pointer mr10 no-bg" @click="remove(scope.row)">
                  <span class="hmicon icon-shanchu primary"></span>
                </button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="添加商品"
      width="70%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleGoods"
    >
      <div class="table-panel flex  flex-end">
        <div class="flex text-right  flex-end">
          <el-input
            clearable
            style="width:200px;"
            v-model.trim="searchDialogCondition.keyWords"
            placeholder="请输入货号/条码/商品名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-cascader
            v-model="searchDialogCondition.wxshopCategoryId"
            :show-all-levels="false"
            size="small"
            class="mr10"
            :props="categoryFunc"
            clearable
            placeholder="请选择微店商品分类"
          ></el-cascader>
          <el-cascader
            v-model="searchDialogCondition.attributeId"
            placeholder="请选择辅助属性"
            :show-all-levels="false"
            size="small"
            class="mr10"
            :props="attributeFunc"
            clearable
          ></el-cascader>
          <el-input
            clearable
            v-model.trim="searchDialogCondition.minPrice"
            placeholder="最低零售价"
            size="small"
            style="width: 100px"
            class="ipt mr10"
          ></el-input>
          <el-input
            clearable
            v-model.trim="searchDialogCondition.maxPrice"
            placeholder="最高零售价"
            size="small"
            style="width: 100px"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="searchGoods"
            >查询</el-button
          >
          <el-button
            type="info"
            size="small"
            @click="searchDialogCondition = {}"
            >重置</el-button
          >
        </div>
      </div>
      <el-table
        stripe
        border
        class="mb20"
        ref="brandTable"
        @selection-change="getMicroChecked"
        :data="wxShopList.records"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentMicroPage - 1) * pageMicroSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="wxshopSpuName"
          label="产品名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="specIdGroupName"
          show-overflow-tooltip
          label="规格"
        >
          <template slot-scope="scope">
            <div>
              <!-- <span>{{ scope.row.spuAttributeValueList.join() }}</span> -->
              <span>{{ scope.row.specIdGroupName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          show-overflow-tooltip
          label="类别"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="spuName"
          label="价格信息"
        >
          <template slot-scope="scope">
            <div>
              <span>零售价：</span>
              <span class="rose">{{ scope.row.wxshopPrice }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="spuName"
          label="是否组合"
        >
          <!-- <template slot-scope="scope">
            <div>
              <span>{{ scope.row.spuName }}</span>
              <span v-if="scope.row.specIdGroupName">{{
                scope.row.specIdGroupName
              }}</span>
            </div>
          </template> -->
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="wxShopList.total"
          @current-change="pagingMicro"
          @size-change="handleSizeMicroChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentMicroPage"
        ></el-pagination>
      </div>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="affirm">确认</el-button>
        <el-button size="small" @click="dialogVisibleGoods = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="批量商品"
      width="70%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <div class="table-panel flex  flex-wrap">
        <el-button type="primary" size="small" @click="dialogVisible = false"
          >继续添加</el-button
        >
      </div>
      <el-radio-group v-model="configType" size="small" class="mb20">
        <el-radio-button label="basicsInfo">基础规则设置</el-radio-button>
        <el-radio-button label="specialTime">时段返佣规则设置</el-radio-button>
        <!-- <el-radio-button label="daoGou">导购统计</el-radio-button> -->
        <!-- <el-radio-button label="jiLu">拦截记录</el-radio-button> -->
      </el-radio-group>
      <div class="mb20 mt10" v-if="configType === 'basicsInfo'">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="product-ruleForm"
        >
          <!-- <el-form-item label="是否批量设置返佣方式：">
            <el-select
              size="small"
              style="width:200px"
              clearable
              @change="isBatch"
              v-model="ruleForm.commissionMode"
              placeholder="请选择批量设置返佣方式"
            >
              <el-option label="积分" value="point"> </el-option>
              <el-option label="货币" value="money"> </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item
            prop="commissionValue"
            label="积分返佣："
            v-if="commType === 'point'"
          >
            <el-input
              clearable
              @keyup="loadNumber($event)"
              type="number"
              style="width:200px;"
              @input="filterFixed2('ruleForm', 'commissionValue')"
              v-model.trim="ruleForm.commissionValue"
              placeholder="请输入积分返佣比例"
              size="small"
              class="ipt mr10"
            ></el-input
            >%
          </el-form-item>
          <el-form-item
            prop="commissionValue"
            label="货币返佣："
            v-if="commType === 'money'"
          >
            <el-input
              type="number"
              @keyup="loadNumber($event)"
              clearable
              style="width:200px;"
              v-model.trim="ruleForm.commissionValue"
              placeholder="请输入货币返佣比例"
              size="small"
              class="ipt mr10"
            ></el-input
            >%
          </el-form-item>
        </el-form>
      </div>
      <div class="mb20 mt10" v-if="configType === 'specialTime'">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="product-ruleForm"
        >
          <el-form-item label="时段返佣规则：" prop="commissionType">
            <el-radio-group
              v-model="ruleForm.commissionType"
              class="margin-right"
              size="small"
            >
              <el-radio label="ratioReturn">比例返佣</el-radio>
              <el-radio label="fixedReturn">固定返佣</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="返佣时段:" prop="applyDate">
            <el-date-picker
              v-model="ruleForm.applyDate"
              type="datetimerange"
              align="right"
              :picker-options="pickerOptions"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="开始时间段筛选"
              end-placeholder="结束时间段筛选"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="返佣比例:"
            prop="commissionValues"
            v-if="ruleForm.commissionType === 'ratioReturn'"
          >
            <el-input
              size="small"
              clearable
              class="mr10 ipt"
              @input="filterFixed2('ruleForm', 'commissionValues')"
              style="width:140px"
              v-model.trim="ruleForm.commissionValues"
              placeholder="请输入返佣比例"
            ></el-input
            >%
          </el-form-item>
          <el-form-item
            label="固定返佣:"
            prop="commissionValues"
            v-if="ruleForm.commissionType === 'fixedReturn'"
          >
            <el-input
              size="small"
              clearable
              @input="filterFixed2('ruleForm', 'commissionValues')"
              style="width:140px"
              class="mr10 ipt"
              v-model.trim="ruleForm.commissionValues"
              placeholder="请输入计件返佣数"
            ></el-input
            >元
          </el-form-item>
        </el-form>
      </div>
      <el-table
        stripe
        border
        class="mb20"
        ref="brandTable"
        @selection-change="getMicroChecked"
        :data="checkedRow"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (goCurrentPage - 1) * goPageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="wxshopSpuName"
          label="商品名称"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.wxshopSpuName }}</span>
            <span v-if="scope.row.specIdGroupName"
              >【{{ scope.row.specIdGroupName }}】</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="seqNum"
          label="价格信息"
        >
          <template slot-scope="scope">
            <div>
              <span>零售价：</span>
              <span class="rose">{{ scope.row.wxshopPrice }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="lastEditTime"
          label="修改日期"
        >
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="lastEditTime"
          label="返佣方式"
        >
          <template slot-scope="scope">
            <template>
              <el-radio v-model="scope.row.commissionMode" label="point"
                >积分</el-radio
              >
              <el-radio v-model="scope.row.commissionMode" label="money"
                >货币</el-radio
              >
            </template>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="删除" placement="top">
                <button
                  class="pointer mr10 no-bg"
                  @click="goRemove(scope.$index, checkedRow)"
                >
                  <span class="hmicon icon-shanchu primary"></span>
                </button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="commType === 'point'">
        <span>当前积分货币比为：</span>
        <span v-if="perUnitMoneyExchangePointsRatio"
          >{{ perUnitMoneyExchangePointsRatio }} : 1</span
        >
        <el-button
          v-if="!perUnitMoneyExchangePointsRatio"
          type="primary"
          size="small"
          @click="gotoRule"
          >去填写积分货币比</el-button
        >
      </div>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="batchAffirm('ruleForm')"
          >确认</el-button
        >
        <el-button size="small" @click="quxiao">取消</el-button>
      </div>
    </el-dialog>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="relInfoList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-tooltip effect="dark" content="Left Center 提示文字" placement="left">
      <div slot="content">
        <div class="mb10">推会员价值：{{ shareCenterPrice.wxshopPrice }}元</div>
        <div class="mb10">
          返佣方式：{{
            shareCenterPrice.commissionMode === "point" ? "积分" : "货币"
          }}返佣
        </div>
        <div>
          返佣值：{{
            shareCenterPrice.commissionMode === "point"
              ? `${shareCenterPrice.pointValue}积分`
              : `${shareCenterPrice.moneyValue}元`
          }}
        </div>
      </div>
      <div class="memberHint ">
        <div class="tubiao flex flex-center">
          <span class="hmicon icon-tuihuiyuanfanyong"></span>
        </div>
        <div style="width:50px;textAlign:center;marginTop:10px;">
          <span style="color:#FFF;">推会员返佣</span>
        </div>
      </div>
    </el-tooltip>
    <el-dialog
      title="特殊返佣时段编辑"
      width="70%"
      :visible.sync="dialogTimeline"
      :close-on-click-modal="false"
    >
      <el-form
        ref="ruleFormTimeline"
        :model="ruleFormTimeline"
        :rules="rulesTimeline"
        label-width="150px"
      >
        <el-form-item label="商品名称：" prop="cardName">
          <div>
            {{ row.wxshopSpuName }}
          </div>
        </el-form-item>
        <el-form-item label="时段返佣规则：" prop="commissionType">
          <el-radio-group
            v-model="ruleFormTimeline.commissionType"
            class="margin-right"
            size="small"
          >
            <el-radio label="ratioReturn">比例返佣</el-radio>
            <el-radio label="fixedReturn">固定返佣</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="返佣时段:" prop="applyDate">
          <el-date-picker
            v-model="ruleFormTimeline.applyDate"
            type="datetimerange"
            align="right"
            :picker-options="pickerOptions"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始时间段筛选"
            end-placeholder="结束时间段筛选"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="返佣比例:"
          prop="commissionValue"
          v-if="ruleFormTimeline.commissionType === 'ratioReturn'"
        >
          <el-input
            size="small"
            clearable
            class="mr10 ipt"
            style="width:140px"
            @input="filterFixed2('ruleFormTimeline', 'commissionValue')"
            v-model.trim="ruleFormTimeline.commissionValue"
            placeholder="请输入返佣比例"
          ></el-input
          >%
        </el-form-item>
        <el-form-item
          label="固定返佣:"
          prop="commissionValue"
          v-if="ruleFormTimeline.commissionType === 'fixedReturn'"
        >
          <el-input
            size="small"
            clearable
            style="width:140px"
            @input="filterFixed2('ruleFormTimeline', 'commissionValue')"
            class="mr10 ipt"
            v-model.trim="ruleFormTimeline.commissionValue"
            placeholder="请输入计件返佣数"
          ></el-input
          >元
        </el-form-item>
        <div class="mb20 flex flex-center">
          <el-button
            type="primary"
            size="small"
            @click="addTimeline('ruleFormTimeline')"
            >添加</el-button
          >
        </div>
        <el-table
          stripe
          border
          class="mb20"
          ref="brandTable"
          :data="timelineList"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column type="index" label="序号"> </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="wxshopSpuName"
            label="返佣时段"
          >
            <template slot-scope="scope">
              <div>
                <span
                  >{{ scope.row.commissionStartTime }}-{{
                    scope.row.commissionEndTime
                  }}</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="commissionType"
            label="返佣规则"
          >
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.commissionType === 'ratioReturn'"
                  >比例返佣</span
                >
                <span v-if="scope.row.commissionType === 'fixedReturn'"
                  >固定返佣</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="specIdGroupName"
            show-overflow-tooltip
            label="返佣"
          >
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.commissionType === 'ratioReturn'"
                  >{{ scope.row.commissionValue }}%</span
                >
                <span v-if="scope.row.commissionType === 'fixedReturn'"
                  >{{ scope.row.commissionValue }}元</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-tooltip class="item" content="删除" placement="top">
                  <div
                    class="pointer mr10"
                    @click="removeTime(scope.$index, scope.row)"
                  >
                    <span class="hmicon icon-shanchu primary"></span>
                  </div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="mb20 flex flex-center">
          <el-button type="primary" size="small" @click="accomplish()"
            >完成</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="导出" width="600px" :visible.sync="dialogOutPut">
      <div class="flex text-right item-center flex-wrap">
        <el-input
          clearable
          v-model.trim="searchOutPut.goodsSn"
          placeholder="请输入货号"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          v-model.trim="searchOutPut.wxshopSpuName"
          placeholder="请输入商品名称"
          size="small"
          class="ipt mr10"
        ></el-input>
      </div>
      <div class="mt10">
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          class="mr10"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchOutPut.applyDate"
          type="datetimerange"
          range-separator="至"
          start-placeholder="选择返佣时间段"
          end-placeholder="选择返佣时间段"
        ></el-date-picker>
      </div>
      <div class="mt10 mb10">
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          class="mr10"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchOutPut.applyDates"
          type="datetimerange"
          range-separator="至"
          start-placeholder="选择修改日期时间段"
          end-placeholder="选择修改日期时间段"
        ></el-date-picker>
      </div>
      <div class="flex flex-center">
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出</el-button
        >
        <el-button type="info" size="small" @click="searchOutPut = {}"
          >重置</el-button
        >
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { setCookie, getCookie } from "@/utils/utils";
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      configType: "basicsInfo",
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 90 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      },
      num: 0,
      row: {},
      commType: "",
      delList: [],
      isOutputing: false,
      dialogOutPut: false,
      commissionValue: "",
      searchOutPut: {},
      searchCondition: {},
      timelineList: [],
      ruleFormTimeline: {
        commissionType: "ratioReturn",
        applyDate: [],
        commissionValue: ""
      },
      rulesTimeline: {
        commissionType: [
          {
            required: true,
            message: "请选择返佣规则",
            trigger: "blur"
          }
        ],
        applyDate: [
          {
            required: true,
            message: "请选择时间段",
            trigger: "blur"
          }
        ],
        commissionValue: [
          {
            required: true,
            message: "请输入返佣值",
            trigger: "blur"
          }
        ]
      },
      perUnitMoneyExchangePointsRatio: "",
      searchDialogCondition: {},
      ruleForm: {
        applyDate: [],
        commissionValue: "",
        commissionValues: "",
        commissionType: "ratioReturn"
      },
      rules: {
        commissionValues: [
          {
            required: true,
            message: "请输入返佣比例",
            trigger: "blur"
          }
        ],
        commissionValue: [
          {
            required: true,
            message: "请输入返佣比例",
            trigger: "blur"
          }
        ],
        commissionType: [
          {
            required: true,
            message: "请选择返佣规则",
            trigger: "blur"
          }
        ],
        applyDate: [
          {
            required: true,
            message: "请选择时间段",
            trigger: "blur"
          }
        ]
      },
      currentPage: 1,
      pageSize: 10,
      goCurrentPage: 1,
      goPageSize: 10,
      currentMicroPage: 1,
      pageMicroSize: 10,
      checkedRow: [],
      checkedMicroRow: [],
      dialogTimeline: false,
      show: false,
      dialogVisible: false,
      dialogVisibleGoods: false,
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.wxshopCategoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: level + 1,
                wxshopParentCategoryId: data.wxshopCategoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.wxshopCategoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      attributeFunc: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          if (level === 0) {
            this.$store.dispatch("queryAttrListByAddGoods").then(res => {
              res.result.forEach(v => {
                v.value = v.valueId;
                v.label = v.attributeValue;
              });
              resolve(res.result);
            });
          } else {
            let params = {};
            if (level === 1) {
              params = {
                typeId: node.data.valueId
              };
            } else {
              params = {
                attributeId: node.data.valueId
              };
            }
            this.$store
              .dispatch("queryAttrListByAddGoods", params)
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.valueId;
                    v.label = v.attributeValue;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      }
    };
  },
  computed: mapGetters([
    "relInfoList",
    "wxShopList",
    "shareCenterPrice",
    "detailsTimeline"
  ]),
  watch: {
    "relInfoList.total": {
      handler(val) {
        if (
          val == (this.currentPage - 1) * this.pageSize &&
          this.pageTotal != 0
        ) {
          this.currentPage -= 1;
          this.queryList();
        }
      },
      deep: true
    }
  },
  created() {
    this.getParamsCookie();
    this.$store.dispatch("detailsRule").then(res => {
      if (res.result) {
        this.commType = res.result.commissionMode;
        this.queryList();
        this.$store.dispatch("shareCenterPrice");
      } else {
        this.$confirm(" 请先设置分销规则", "提示", {
          // cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning"
        })
          .then(() => {
            this.$router.push({
              name: "DistributionRule"
            });
          })
          .catch(() => {
            this.$router.push({
              name: "DistributionRule"
            });
          });
      }
    });
  },
  mounted() {},
  methods: {
    loadNumber: function(event) {
      var el = event.currentTarget;
      var elValue = el.value;
      var reg = /^(0.\d+|0|1)$/;
      if (!elValue.match(reg)) {
        elValue = "";

        return false;
      } else {
        return true;
      }
    },
    filterIntegerByPurchase(index, prop) {
      this.relInfoList.records[index].commissionValue = prop
        .replace(".", "")
        .replace("-", "");
    },
    blur(list, prop, i) {
      if (
        this.relInfoList.records[i][prop] >= 0.01 &&
        this.relInfoList.records[i][prop] <= 100
      ) {
        this.relInfoList.records[i][prop] = this.relInfoList.records[i][prop];
      } else {
        this.relInfoList.records[i][prop] = "";
        this.$message({
          message: "比例最高输入100最低输入0.01",
          type: "warning"
        });
      }
    },
    filterFixed2(ruleForm, prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this[ruleForm][prop] = this[ruleForm][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this[ruleForm][prop] = this[ruleForm][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this[ruleForm][prop] = this[ruleForm][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this[ruleForm][prop] = this[ruleForm][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this[ruleForm][prop].indexOf(".") < 0 && this[ruleForm][prop] != "") {
        //首位是0的话去掉
        this[ruleForm][prop] = parseFloat(this[ruleForm][prop]);
      }
    },
    filterGt0OrFixed2(prop, i) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头

      // if (
      //   this.relInfoList.records[i][prop] >= 0.01 &&
      //   this.relInfoList.records[i][prop] <= 100
      // ) {
      //   this.relInfoList.records[i][prop] = this.relInfoList.records[i][prop];
      // } else {
      //   this.relInfoList.records[i][prop] = "";
      // }
      this.relInfoList.records[i][prop] = this.relInfoList.records[i][
        prop
      ].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.relInfoList.records[i][prop] = this.relInfoList.records[i][
        prop
      ].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.relInfoList.records[i][prop] = this.relInfoList.records[i][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.relInfoList.records[i][prop] = this.relInfoList.records[i][
        prop
      ].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (
        this.relInfoList.records[i][prop].indexOf(".") < 0 &&
        this.relInfoList.records[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.relInfoList.records[i][prop] = parseFloat(
          this.relInfoList.records[i][prop]
        );
      }
    },
    isBatch(val) {
      this.checkedRow.forEach(v => {
        v.commissionMode = val;
      });
    },
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      this.setParamsCookie();
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.wxshopCategoryId = this.isArray(
        searchCondition.wxshopCategoryId
      )
        ? searchCondition.wxshopCategoryId[
            searchCondition.wxshopCategoryId.length - 1
          ]
        : searchCondition.wxshopCategoryId;

      searchCondition.attributeId = this.isArray(searchCondition.attributeId)
        ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
        : "";
      Object.assign(params, searchCondition);

      return this.$store.dispatch("queryRelInfoList", params);
    },
    queryAllList() {
      let params = {
        pageSize: 999999,
        pageNo: 1
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchOutPut));
      searchCondition.commissionStartTime = this.isArray(
        searchCondition.applyDate
      )
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.commissionEndTime = this.isArray(
        searchCondition.applyDate
      )
        ? searchCondition.applyDate[1]
        : "";
      searchCondition.updateTimeStart = this.isArray(searchCondition.applyDates)
        ? searchCondition.applyDates[0]
        : "";
      searchCondition.updateTimeEnd = this.isArray(searchCondition.applyDates)
        ? searchCondition.applyDates[1]
        : "";

      Object.assign(params, searchCondition);

      return this.$store.dispatch("queryAllRelInfoList", params);
    },
    setParamsCookie() {
      setCookie({
        key: "distributionProductsParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({
        key: "distributionProductsParams",
        type: "session"
      });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },

    queryMicroShopGoodsList() {
      let params = {
        pageSize: this.pageMicroSize,
        pageNo: this.currentMicroPage
      };
      const searchDialogCondition = JSON.parse(
        JSON.stringify(this.searchDialogCondition)
      );
      searchDialogCondition.wxshopCategoryId = this.isArray(
        searchDialogCondition.wxshopCategoryId
      )
        ? searchDialogCondition.wxshopCategoryId[
            searchDialogCondition.wxshopCategoryId.length - 1
          ]
        : searchDialogCondition.wxshopCategoryId;

      searchDialogCondition.attributeId = this.isArray(
        searchDialogCondition.attributeId
      )
        ? searchDialogCondition.attributeId[
            searchDialogCondition.attributeId.length - 1
          ]
        : "";
      Object.assign(params, searchDialogCondition);
      // this.relInfoList.records.wxshopSkuId

      return this.$store.dispatch("queryWxshopList", params);
    },
    sortChange(sort) {
      //   this.sort = sort;
      //   this.queryList();
    },
    accomplish() {
      let params = {
        shareSkuId: this.row.shareSkuId,
        shareSkuConfigCalendars: this.timelineList
      };
      this.$store.dispatch("saveTimeline", params).then(res => {
        if (res.code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryList();
          this.dialogTimeline = false;
          this.timelineList = [];
        }
      });
    },
    setTimeline(row) {
      this.row = row;
      this.dialogTimeline = true;
      let params = {
        shareSkuId: row.shareSkuId
      };
      this.$store.dispatch("detailsTimeline", params).then(res => {
        if (res.code === "0") {
          this.timelineList = res.result;
          [...this.delList] = res.result;
        }
      });
    },
    addTimeline(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const searchCondition = JSON.parse(
            JSON.stringify(this.ruleFormTimeline)
          );
          let newStartTime = new Date(searchCondition.applyDate[0]).getTime();
          let flag = false;
          this.timelineList.map(v => {
            let oldEndTime = new Date(v.commissionEndTime).getTime();
            if (oldEndTime >= newStartTime) {
              flag = true;
            }
          });
          searchCondition.commissionStartTime =
            searchCondition.applyDate && searchCondition.applyDate.length > 0
              ? searchCondition.applyDate[0]
              : "";
          searchCondition.commissionEndTime =
            searchCondition.applyDate && searchCondition.applyDate.length > 0
              ? searchCondition.applyDate[1]
              : "";
          if (flag) {
            this.$message({
              message: "返佣时段不能重叠!",
              type: "warning"
            });
          } else {
            this.timelineList.push(searchCondition);
            setTimeout(() => {
              this.ruleFormTimeline.applyDate = [];
              this.ruleFormTimeline.commissionValue = "";
            }, 0);
          }
        }
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    pagingMicro(page) {
      this.currentMicroPage = page;
      this.queryMicroShopGoodsList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    handleSizeMicroChange(size) {
      this.currentMicroPage = 1;
      this.pageMicroSize = size;
      this.queryMicroShopGoodsList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    searchGoods() {
      this.currentMicroPage = 1;
      this.queryMicroShopGoodsList();
    },
    addGoods() {
      this.dialogVisibleGoods = true;
      this.queryMicroShopGoodsList();
    },
    batchSetting() {
      if (this.checkedRow.length) {
        this.dialogVisible = true;
        this.$store.dispatch("detailsRule").then(res => {
          if (res.code == "0") {
            if (res.result) {
              this.perUnitMoneyExchangePointsRatio =
                res.result.perUnitMoneyExchangePointsRatio;
            } else {
              this.$message({
                message: "请填写分销规则积分货币比",
                type: "warning"
              });
            }
          }
        });
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    batchDelete() {
      if (this.checkedRow.length) {
        this.$confirm(" 是否确认删除?", "提示", {
          cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning"
        }).then(() => {
          let shareSkuIds = this.checkedRow.map(v => v.shareSkuId);
          this.$store
            .dispatch("delRelInfo", {
              shareSkuIds
            })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
                this.queryList();
              }
            });
        });
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    getMicroChecked(selection) {
      this.checkedMicroRow = selection;
    },
    getChecked(selection) {
      this.checkedRow = selection;
      this.num = selection.length;
    },
    save(row) {
      row.commissionMode = this.commType;
      this.$store.dispatch("editRelInfo", row).then(res => {
        if (res.code === "0") {
          row.disabled = true;
          this.$forceUpdate();
        }
      });
    },
    toDetails(row) {
      this.$router.push({
        name: "DetailsDistributionGoods",
        query: {
          wxshopSpuId: row.wxshopSpuId,
          skuId: row.skuId
        }
      });
    },
    edit(row, index) {
      row.disabled = false;
      this.$forceUpdate();
    },
    removeTime(index, row) {
      this.$confirm(" 是否确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        if (row.id) {
          row.hidden = "yes";
          this.timelineList.splice(index, 1);
          this.delList.forEach(v => {
            if (v.id === row.id) {
              v.hidden = "yes";
            }
          });
        } else {
          this.timelineList.splice(index, 1);
        }
      });
    },
    remove(row) {
      this.$confirm(" 是否确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        let shareSkuIds = [row.shareSkuId];

        this.$store
          .dispatch("delRelInfo", {
            shareSkuIds
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    },

    affirm() {
      let params = {
        goodsInfoBos: this.checkedMicroRow
      };
      this.$store.dispatch("addRelInfo", params).then(res => {
        if (res.code === "0") {
          this.dialogVisibleGoods = false;
          this.queryList();
        }
      });
    },
    batchAffirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.ruleForm));
          params.skuInfoBos = this.checkedRow;
          // params.commissionValue = this.ruleForm.commissionValue;
          params.commissionMode = this.commType;
          params.configType = this.configType;

          params.commissionStartTime =
            params.applyDate && params.applyDate.length > 0
              ? params.applyDate[0]
              : "";
          params.commissionEndTime =
            params.applyDate && params.applyDate.length > 0
              ? params.applyDate[1]
              : "";
          this.$store.dispatch("editBatchRelInfo", params).then(res => {
            if (res.code === "0") {
              this.dialogVisible = false;
              setTimeout(() => {
                this.resetRuleForm();
              }, 0);
              this.queryList();
            }
          });
        }
      });
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(res => {
            const list = res.result.records;
            // list.forEach(v => {
            //   v.wxshopSpuName =
            //     v.specIdGroupName !== ""
            //       ? v.wxshopSpuName + "【" + v.specIdGroupName + "】"
            //       : v.wxshopSpuName;
            //   v.wxshopPrice = "零售价：" + v.wxshopPrice;
            //   if (v.commissionValue) {
            //     v.commissionValue = (v.commissionValue * 100).toFixed(2) + "%";
            //   } else {
            //     v.commissionValue = "";
            //   }
            // });
            const tHeader = [
              "返佣开始时段",
              "返佣结束时段",
              "货号",
              "商品名称",
              "零售价",
              "返佣时段规则",
              "返佣金额/比例",
              "特殊时段返佣规则数",
              "修改日期"
            ];
            const filterVal = [
              "commissionStartTime",
              "commissionEndTime",
              "goodsSn",
              "wxshopSpuName",
              "wxshopPrice",
              "commissionType",
              "moneyValue",
              "commissionValue",
              "updateTime"
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "分销商品列表" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    goRemove(index, rows) {
      rows.splice(index, 1);
    },
    handleClose(done) {
      done();
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    quxiao() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm.commissionMode = "";
      this.ruleForm.commissionType = "ratioReturn";
    },
    gotoRule() {
      this.$router.push({
        name: "DistributionRule"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.rose {
  color: #e50065;
}
.batch {
  div {
    margin: 20px 0;
    cursor: pointer;
    font-size: 14px;
    color: #222222;
    user-select: none;
    &:first-child {
      margin-right: 20px;
    }
  }
  .hmicon {
    margin-right: 5px;
  }
}
.table {
  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }
  .table-row {
    padding: 5px 0;
    font-size: 14px;
  }
  .table-row:nth-child(odd) {
    background: #f7f7f7;
  }
  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}
.memberHint {
  width: 50px;
  height: 100px;
  background-color: #e60e6d;
  position: fixed;
  right: -30px;
  // right: 0;
  bottom: 200px;
  z-index: 2;

  .tubiao {
    width: 50px;
    height: 50px;
    // text-align: center;

    span {
      font-size: 30px;
      margin-top: 14px;
      color: #f7f7f7;
    }
  }
}
.memberHint:hover {
  position: fixed;
  right: 0;
  bottom: 200px;
  z-index: 2;
  // transform: translateX(-9px);
}
</style>
